module.exports = __webpack_public_path__ + "static/专精特新-bbb34b4c64d5ac40b8adf88300ec57d9.jpg";